export default "__VITE_ASSET__876911bb__"